import { HubConnectionBuilder, HubConnection, HubConnectionState } from '@microsoft/signalr';
import { WEBSOCKET_URL } from 'projectConfig';
import { getAccessToken } from 'auth';

export interface Message {
  type: string;
  message: string;
}

interface EventHandler {
  (message: Message): void;
}

export interface WebsocketClientInstance {
  socket: () => HubConnection;
  startIfNeeded: () => Promise<void>;
  on: (name: string, handler: EventHandler) => void;
}

const accessTokenFactory = async () => {
  const accessTokenResponse = await getAccessToken();
  return accessTokenResponse?.accessToken || '';
};

class WebsocketClient {
  private connection: HubConnection;
  public static instance: WebsocketClientInstance | undefined;

  constructor() {
    this.connection = new HubConnectionBuilder()
      .withUrl(WEBSOCKET_URL, {
        accessTokenFactory, // this will attach an access_token to query parameters
      })
      .withAutomaticReconnect()
      .build();
  }

  static getInstance(): WebsocketClientInstance {
    if (!WebsocketClient.instance) {
      WebsocketClient.instance = new WebsocketClient();
    }
    return WebsocketClient.instance;
  }


  async startIfNeeded() {
    try {
      if (this.connection.state !== HubConnectionState.Disconnected) {
        return;
      }
      await this.connection.start();
      // this.connection.on('ReceiveMessage', eventHandler);
    } catch (e) {
      // Cannot start a websocket connection, ignore
    }
  }

  socket() {
    return this.connection;
  }

  on(eventName: string, eventHandler: EventHandler) {
    if (this.connection) {
      this.connection.on(eventName, eventHandler);
    }
  }
}

export default WebsocketClient;
